export enum TypeEnum {
  question = 'Anwendungsfrage',
  wish = 'Idee',
  problem = 'Störung'
}
